import type {FilenameSchemaEntry} from "#material-outputs-filenames/types"
import {schemas as kravetSchemas} from "#material-outputs-filenames/schemas/kravet"

export const organizationName = "brunschwig & fils" as const

// brunschwig & fils uses the same schemas as kravet, so we can just re-export them here
export const schemas: FilenameSchemaEntry[] = [...kravetSchemas]
